/* NINNA PRO — JS global (vanilla) */
(function () {
  'use strict';
  var NP = (window.NP = window.NP || {});
  var FAV_KEY = 'np_favs', SEEN_KEY = 'np_seen';
  function ls(k, v) {
    try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || '[]'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return []; }
  }
  NP.ls = ls;

  /* ---------- Toast ---------- */
  var toastEl;
  NP.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'np-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  };

  /* ---------- Colores de swatches ---------- */
  var COLORS = { blanco: '#fff', negro: '#111', beige: '#d9c7a7', celeste: '#a9c8e6', rosa: '#f2b8c6', rojo: '#b3202a', chocolate: '#5a3a26', choco: '#5a3a26', crudo: '#efe6d4', gris: '#9a9a9a', lila: '#c8a8d8', tostado: '#c49a6c', marrón: '#6b4a32', marron: '#6b4a32', 'verde oliva': '#6b6b3a', uva: '#5b2a4a', 'azul jean': '#3d5a80', 'celeste jean': '#8fb0cf', 'rayas celestes': '#bcd3ea', 'rayas beige': '#e2d4bb' };
  function paintSwatches(root) {
    root.querySelectorAll('[data-np-color]').forEach(function (i) {
      var n = i.getAttribute('data-np-color'); var c = COLORS[n];
      if (!c) { Object.keys(COLORS).some(function (k) { if (n.indexOf(k) > -1) { c = COLORS[k]; return true; } }); }
      i.style.background = c || '#ddd';
    });
  }

  /* ---------- Carrito ---------- */
  NP.refreshCart = function (sections) {
    var html = sections && sections['cart-drawer-section'];
    var p = html ? Promise.resolve(html) : fetch('/?sections=cart-drawer-section').then(function (r) { return r.json(); }).then(function (j) { return j['cart-drawer-section']; });
    return p.then(function (h) {
      if (!h) return;
      var doc = new DOMParser().parseFromString(h, 'text/html');
      var fresh = doc.querySelector('.cart-drawer__inner');
      var cur = document.querySelector('cart-drawer-component .cart-drawer__inner');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      if (fresh && cur) cur.className = fresh.className;
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      if (!cart) return;
      document.querySelectorAll('.cart-bubble__text-count, [data-np-cartcount]').forEach(function (b) { b.textContent = cart.item_count; });
      document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', cart.item_count === 0); });
      try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'np', data: { source: 'np', itemCount: cart.item_count } } })); } catch (e) {}
      initAll(document.querySelector('cart-drawer-component') || document);
    });
  };
  NP.openCart = function () {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.showDialog === 'function') return d.showDialog();
    if (d && typeof d.open === 'function') return d.open();
    var btn = document.querySelector('[on\\:click*="cart-drawer/open"], .header-actions__cart-icon, a[href="/cart"]');
    if (btn) btn.click(); else location.href = '/cart';
  };
  NP.add = function (id, qty, card) {
    if (card) card.classList.add('is-adding');
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }], sections: 'cart-drawer-section' })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { return NP.refreshCart(j.sections); })
      .then(function () { NP.openCart(); })
      .catch(function (e) { NP.toast((e && (e.description || e.message)) || 'No se pudo agregar'); })
      .finally(function () { if (card) { card.classList.remove('is-adding', 'qa-open'); } });
  };

  /* ---------- Tarjeta ---------- */
  function initCard(card) {
    if (card._np) return; card._np = 1;
    var track = card.querySelector('[data-np-track]');
    var bars = card.querySelectorAll('.np-card__bars span');
    var prev = card.querySelector('[data-np-prev]'), next = card.querySelector('[data-np-next]');
    if (track) {
      var upd = function () {
        var w = track.clientWidth || 1, i = Math.round(track.scrollLeft / w), n = track.children.length;
        bars.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        if (prev) prev.hidden = i <= 0; if (next) next.hidden = i >= n - 1;
      };
      track.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: -track.clientWidth }); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); track.scrollBy({ left: track.clientWidth }); });
    }
    // talles
    var dataEl = card.querySelector('[data-np-variants]'), box = card.querySelector('[data-np-sizes]');
    var si = parseInt(card.dataset.sizeIndex, 10), ci = parseInt(card.dataset.colorIndex, 10), low = parseInt(card.dataset.low || '3', 10);
    if (dataEl && box && si >= 0) {
      var vs = []; try { vs = JSON.parse(dataEl.textContent); } catch (e) {}
      var color = ci >= 0 && vs[0] ? vs[0].c[ci] : null;
      var seen = {};
      vs.forEach(function (v) {
        if (color !== null && v.o[ci] !== color) return;
        var s = v.o[si]; if (seen[s]) return; seen[s] = 1;
        var b = document.createElement('button'); b.type = 'button'; b.textContent = s;
        if (!v.a) { b.disabled = true; b.title = 'Agotado'; }
        else if (v.q > 0 && v.q <= low) { b.classList.add('is-low'); b.title = 'Últimas unidades'; }
        b.addEventListener('click', function (e) { e.preventDefault(); NP.add(v.id, 1, card); });
        box.appendChild(b);
      });
    }
    card.querySelectorAll('[data-np-add]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); NP.add(parseInt(b.getAttribute('data-np-add'), 10), 1, card); });
    });
    var plus = card.querySelector('[data-np-plus]');
    if (plus) plus.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelectorAll('.np-card.qa-open').forEach(function (c) { if (c !== card) c.classList.remove('qa-open'); });
      card.classList.toggle('qa-open');
    });
    paintSwatches(card);
  }

  /* ---------- Favoritos ---------- */
  function favRender() {
    var f = ls(FAV_KEY);
    document.querySelectorAll('[data-np-fav]').forEach(function (b) {
      var on = f.indexOf(b.getAttribute('data-np-fav')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      b.setAttribute('aria-label', on ? 'Quitar de favoritos' : 'Agregar a favoritos');
    });
    document.querySelectorAll('[data-np-favcount]').forEach(function (c) { c.textContent = f.length || ''; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-np-fav]'); if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-np-fav'), f = ls(FAV_KEY), i = f.indexOf(h);
    if (i > -1) { f.splice(i, 1); NP.toast('Quitado de favoritos'); } else { f.unshift(h); NP.toast('Guardado en favoritos ♥'); }
    ls(FAV_KEY, f.slice(0, 60)); favRender();
    var page = document.querySelector('[data-np-favpage]'); if (page && i > -1) renderFavPage(page);
  });
  function injectFavIcon() {
    if (document.querySelector('.np-favcount')) return;
    var cart = document.querySelector('.header-actions__cart-icon, header-actions cart-icon, .header__icon--cart, a[href="/cart"]');
    if (!cart) return;
    var a = document.createElement('a'); a.href = '/pages/favoritos'; a.className = 'np-favcount'; a.setAttribute('aria-label', 'Favoritos');
    a.innerHTML = "<svg viewBox='0 0 24 24'><path d='M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z'/></svg><b data-np-favcount></b>";
    cart.parentNode.insertBefore(a, cart);
  }
  function renderFavPage(page) {
    var f = ls(FAV_KEY), grid = page.querySelector('[data-np-favgrid]'), empty = page.querySelector('[data-np-favempty]');
    grid.innerHTML = ''; empty.hidden = f.length > 0;
    Promise.all(f.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '?section_id=card-render').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (list) {
      list.forEach(function (html) {
        if (!html) return; var d = document.createElement('div'); d.innerHTML = html;
        var c = d.querySelector('[data-np-card]'); if (c) grid.appendChild(c);
      });
      initAll(grid); favRender();
    });
  }

  /* ---------- Vistos recientemente ---------- */
  function trackSeen() {
    var el = document.querySelector('[data-np-seen-handle]'); if (!el) return;
    var h = el.getAttribute('data-np-seen-handle'), s = ls(SEEN_KEY).filter(function (x) { return x !== h; });
    s.unshift(h); ls(SEEN_KEY, s.slice(0, 12));
  }
  function renderSeen(box) {
    var cur = box.getAttribute('data-np-recent'), s = ls(SEEN_KEY).filter(function (x) { return x !== cur; }).slice(0, 8);
    if (!s.length) return;
    var rail = box.querySelector('[data-np-recent-rail]');
    Promise.all(s.map(function (h) { return fetch('/products/' + encodeURIComponent(h) + '?section_id=card-render').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }); }))
      .then(function (list) {
        list.forEach(function (html) { var d = document.createElement('div'); d.innerHTML = html; var c = d.querySelector('[data-np-card]'); if (c) rail.appendChild(c); });
        if (rail.children.length) { box.hidden = false; initAll(rail); favRender(); }
      });
  }

  /* ---------- Pestañas de categorías (home) ---------- */
  function initTabs(root) {
    root.querySelectorAll('[data-np-tabs]').forEach(function (w) {
      if (w._np) return; w._np = 1;
      var tabs = w.querySelectorAll('[data-np-tab]'), panels = w.querySelectorAll('[data-np-panel]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var k = t.getAttribute('data-np-tab');
          tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-np-panel') !== k; });
          t.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
        });
      });
    });
    root.querySelectorAll('[data-np-railwrap]').forEach(function (w) {
      if (w._np) return; w._np = 1;
      var r = w.querySelector('.np-rail'), p = w.querySelector('[data-np-rprev]'), n = w.querySelector('[data-np-rnext]');
      if (!r) return;
      if (p) p.addEventListener('click', function () { r.scrollBy({ left: -r.clientWidth * 0.8, behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { r.scrollBy({ left: r.clientWidth * 0.8, behavior: 'smooth' }); });
    });
  }

  /* ---------- FAQ: uno abierto a la vez ---------- */
  function initAccordions(root) {
    root.querySelectorAll('[data-np-accordion]').forEach(function (g) {
      if (g._np) return; g._np = 1;
      g.querySelectorAll('details').forEach(function (d) {
        d.addEventListener('toggle', function () { if (d.open) g.querySelectorAll('details').forEach(function (o) { if (o !== d) o.open = false; }); });
      });
    });
  }

  /* ---------- Banda de confianza ---------- */
  function initTrust(root) {
    root.querySelectorAll('[data-np-trust]').forEach(function (t) {
      if (t._np) return; t._np = 1;
      var s = t.querySelectorAll('span'), i = 0; if (s.length < 2) return;
      setInterval(function () { s[i].classList.remove('is-on'); i = (i + 1) % s.length; s[i].classList.add('is-on'); }, 3200);
    });
  }

  /* ---------- Colección: scroll infinito + vista ---------- */
  function initCollection(root) {
    root.querySelectorAll('[data-np-coll]').forEach(function (c) {
      if (c._np) return; c._np = 1;
      var grid = c.querySelector('[data-np-collgrid]'), more = c.querySelector('[data-np-more]');
      var KEY = 'np_cols';
      var setCols = function (n) { grid.style.setProperty('--np-cols-m', n); c.querySelectorAll('[data-np-cols]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-np-cols') === String(n)); }); try { localStorage.setItem(KEY, n); } catch (e) {} };
      var saved = null; try { saved = localStorage.getItem(KEY); } catch (e) {}
      setCols(saved || 2);
      c.querySelectorAll('[data-np-cols]').forEach(function (b) { b.addEventListener('click', function () { setCols(b.getAttribute('data-np-cols')); }); });
      var panel = c.querySelector('[data-np-filters]');
      c.querySelectorAll('[data-np-filters-open]').forEach(function (b) { b.addEventListener('click', function () { panel.showModal(); }); });
      c.querySelectorAll('[data-np-filters-close]').forEach(function (b) { b.addEventListener('click', function () { panel.close(); }); });
      if (!more) return;
      var loading = false;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting || loading) return;
        var url = more.getAttribute('data-np-more'); if (!url) return;
        loading = true;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html');
          d.querySelectorAll('[data-np-collgrid] > *').forEach(function (n) { grid.appendChild(n); });
          var nm = d.querySelector('[data-np-more]');
          if (nm && nm.getAttribute('data-np-more')) more.setAttribute('data-np-more', nm.getAttribute('data-np-more'));
          else { io.disconnect(); more.remove(); }
          initAll(grid); favRender(); loading = false;
        }).catch(function () { loading = false; });
      }, { rootMargin: '600px' });
      io.observe(more);
    });
  }

  /* ---------- Count-up ---------- */
  function initCount(root) {
    root.querySelectorAll('[data-np-count]').forEach(function (el) {
      if (el._np) return; el._np = 1;
      var target = parseFloat(el.getAttribute('data-np-count')) || 0;
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return; io.disconnect();
        var t0 = performance.now();
        (function step(t) { var p = Math.min(1, (t - t0) / 1200); el.textContent = Math.round(target * p).toLocaleString('es-UY'); if (p < 1) requestAnimationFrame(step); })(t0);
      });
      io.observe(el);
    });
  }


  /* ---------- Extras del carrito lateral ---------- */
  function money(c) { return '$' + Math.round(c / 100).toLocaleString('es-UY'); }
  var cartBusy = false, cartTimer;
  function cartExtras() {
    var inner = document.querySelector('cart-drawer-component .cart-drawer__inner');
    if (!inner || cartBusy) return;
    cartBusy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      inner.querySelectorAll('.np-ship,.np-cartlook,.np-saved,.np-empty-links,.np-carttrust,.np-promo').forEach(function (n) { n.remove(); });
      var cfg = window.NP_CFG || {};
      if (!cart.item_count) {
        var ec = inner.querySelector('.cart-drawer__content') || inner;
        if (cfg.cats && cfg.cats.length) {
          var el = document.createElement('div'); el.className = 'np-empty-links';
          cfg.cats.forEach(function (c) { var a = document.createElement('a'); a.className = 'np-chip'; a.href = c.u; a.textContent = c.t; el.appendChild(a); });
          ec.appendChild(el);
        }
        return;
      }
      var content = inner.querySelector('.cart-drawer__content'), items = inner.querySelector('.cart-drawer__items'), summary = inner.querySelector('.cart-drawer__summary');
      if (cfg.freeShip > 0 && content) {
        var left = cfg.freeShip - cart.total_price, pct = Math.min(100, Math.round(cart.total_price * 100 / cfg.freeShip));
        var sb = document.createElement('div'); sb.className = 'np-ship' + (left <= 0 ? ' is-done' : '');
        sb.innerHTML = '<span>' + (left <= 0 ? '¡Ya tenés envío gratis en Montevideo! 🎉' : 'Te faltan <b>' + money(left) + '</b> para el envío gratis') + '</span><div class="np-ship__bar"><i style="width:' + pct + '%"></i></div>';
        content.insertBefore(sb, content.firstChild);
      }
      var pr = cfg.promo || {}, nCam = 0, promoOpen = false;
      if (pr.ids && pr.ids.length) cart.items.forEach(function (i) { if (pr.ids.indexOf(i.product_id) > -1) nCam += i.quantity; });
      if (nCam > 0 && content) {
        var pb = document.createElement('div');
        if (nCam % 2 === 1) {
          promoOpen = true;
          pb.className = 'np-promo';
          pb.innerHTML = '<div class="np-promo__head"><b>🎁 Sumá otra camisa y ahorrá ' + money(pr.off) + '</b><span>Combiná modelos y colores. El descuento se aplica solo, sin código.</span></div><div class="np-rail np-noscroll" hidden></div>';
          var prail = pb.querySelector('.np-rail'), pin = {};
          cart.items.forEach(function (i) { pin[i.handle] = 1; });
          fetch('/collections/' + pr.h + '?section_id=np-recs').then(function (r) { return r.ok ? r.text() : ''; }).then(function (h) {
            var d = document.createElement('div'); d.innerHTML = h; var rest = [];
            d.querySelectorAll('[data-np-card]').forEach(function (c) { if (pin[c.dataset.handle]) rest.push(c); else if (prail.children.length < 8) prail.appendChild(c); });
            rest.forEach(function (c) { if (prail.children.length < 8) prail.appendChild(c); });
            if (prail.children.length) { prail.hidden = false; initAll(pb); favRender(); }
          }).catch(function () {});
        } else {
          pb.className = 'np-promo is-done';
          pb.innerHTML = '<div class="np-promo__head"><b>✓ Promo 2 camisas aplicada</b><span>Ahorrás ' + money(pr.off * Math.floor(nCam / 2)) + ' en este pedido.</span></div>';
        }
        var shipEl = content.querySelector('.np-ship');
        content.insertBefore(pb, shipEl ? shipEl.nextSibling : content.firstChild);
      }
      if (summary) {
        if (cart.total_discount > 0) { var sv = document.createElement('div'); sv.className = 'np-saved'; sv.textContent = 'Ahorrás ' + money(cart.total_discount); summary.insertBefore(sv, summary.firstChild); }
        if (cfg.cartTrust) { var tr = document.createElement('div'); tr.className = 'np-carttrust'; tr.style.cssText = 'font-size:12px;color:var(--np-muted);text-align:center'; tr.textContent = cfg.cartTrust; summary.appendChild(tr); }
      }
      if (items) {
        var inCart = {}; cart.items.forEach(function (i) { inCart[i.handle] = 1; });
        var look = document.createElement('div'); look.className = 'np-cartlook'; look.hidden = true;
        look.innerHTML = '<h3>Completá tu look</h3><div class="np-rail np-noscroll"></div>';
        items.parentNode.insertBefore(look, items.nextSibling);
        var rail = look.querySelector('.np-rail');
        var get = function (u) { return fetch(u).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }); };
        var add = function (h) { var d = document.createElement('div'); d.innerHTML = h; d.querySelectorAll('[data-np-card]').forEach(function (c) { var k = c.dataset.handle; if (inCart[k] || rail.children.length >= 8 || (promoOpen && pr.hs && pr.hs.indexOf(k) > -1)) return; inCart[k] = 1; rail.appendChild(c); }); };
        var pid = cart.items[0].product_id;
        get('/recommendations/products?product_id=' + pid + '&limit=10&intent=complementary&section_id=np-recs').then(add)
          .then(function () { if (rail.children.length < 3) return get('/recommendations/products?product_id=' + pid + '&limit=10&section_id=np-recs').then(add); })
          .then(function () { if (rail.children.length < 3 && cfg.lookCollection) return get('/collections/' + cfg.lookCollection + '?section_id=np-recs').then(add); })
          .then(function () { if (rail.children.length) { look.hidden = false; initAll(look); favRender(); } });
      }
    }).finally(function () { setTimeout(function () { cartBusy = false; }, 300); });
  }
  NP.cartExtras = cartExtras;

  /* ---------- Aviso promo en ficha ---------- */
  function pdpPromo() {
    var el = document.querySelector('[data-np-pdp]'), pr = (window.NP_CFG || {}).promo || {};
    if (!el || !pr.ids || !pr.ids.length || el.querySelector('.np-promo2')) return;
    var pid = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.id;
    var go = function (id) {
      if (pr.ids.indexOf(id) < 0) return;
      var b = document.createElement('div'); b.className = 'np-promo2';
      b.innerHTML = '<b>🎁 Llevá 2 camisas y ahorrá ' + money(pr.off) + '</b><span>Combiná modelos y colores como quieras. El descuento se aplica solo en el carrito, sin código.</span>';
      var st = el.querySelector('[data-np-stock]'); el.insertBefore(b, st ? st.nextSibling : el.firstChild);
    };
    if (pid) go(pid); else fetch('/products/' + el.getAttribute('data-np-seen-handle') + '.js').then(function (r) { return r.json(); }).then(function (p) { go(p.id); }).catch(function () {});
  }
  function watchCart() {
    var comp = document.querySelector('cart-drawer-component');
    if (!comp) return;
    var mo = new MutationObserver(function (ms) {
      var own = ms.every(function (m) { return [].every.call(m.addedNodes, function (n) { return n.nodeType !== 1 || (n.closest && n.closest('.np-ship,.np-cartlook,.np-saved,.np-empty-links,.np-carttrust,.np-promo,[data-np-card]')); }); });
      if (own) return;
      clearTimeout(cartTimer); cartTimer = setTimeout(cartExtras, 250);
    });
    mo.observe(comp, { childList: true, subtree: true });
    cartExtras();
  }

  function initAll(root) {
    root = root || document;
    root.querySelectorAll('[data-np-card]').forEach(initCard);
    initTabs(root); initAccordions(root); initTrust(root); initCollection(root); initCount(root);
  }
  NP.initAll = initAll;

  function boot() {
    injectFavIcon(); initAll(document); favRender(); trackSeen(); watchCart(); pdpPromo();
    var fp = document.querySelector('[data-np-favpage]'); if (fp) renderFavPage(fp);
    document.querySelectorAll('[data-np-recent]').forEach(renderSeen);
    // re-inicializar tarjetas que aparecen dinámicamente (carrito, recomendaciones)
    var mo = new MutationObserver(function (ms) {
      var hit = false;
      ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) { if (n.matches && n.matches('[data-np-card]')) { initCard(n); hit = true; } else if (n.querySelector && n.querySelector('[data-np-card],[data-np-tabs],[data-np-accordion]')) { initAll(n); hit = true; } } }); });
      if (hit) favRender();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.np-card')) document.querySelectorAll('.np-card.qa-open').forEach(function (c) { c.classList.remove('qa-open'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
